export default "__VITE_ASSET__a2d326ec__"